<template>
  <div>
    <div class="search-form">
      <div class="search-form-left">
        <div class="form">
          <a-form-model
            layout="inline"
            :model="form"
          >
            <a-form-model-item
              label="自然年度"
            >
              <a-select
                v-model="form.year"
                placeholder="请选择自然年度"
                allow-clear
                show-search
              >
                <a-select-option
                  v-for="item in yearsOptions"
                  :key="item.year"
                >
                  {{ item.year }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model>
        </div>

        <div class="ant-btns-mrright">
          <TableActions
            :actions="headerActions"
            @check="queryTotal"
          />
        </div>
      </div>
    </div>
    <div class="table">
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        style="padding: 16px 0; background-color: #fff;"
        :row-key="(item, index) => index"
        :scroll="{ x: 1200 }"
        :pagination="false"
      />
    </div>
    <div class="m-chart">
      <div
        id="mychart"
        class="mychart"
      />

      <div
        id="myPieChart"
        class="myPieChart"
      />
    </div>
  </div>
</template>

<script>
import { queryIncomeStatisticDetails } from '@/api/analyzer.js'

const headerActions = [
  {
    title: '查询',
    type: 'primary',
    action: 'check'
  }
]

export default {
  data () {
    return {
      headerActions,
      columns: [],
      dataSource: [],
      dataMonths: [],
      loading: false,
      baseId: 0,
      baseOptions: [],
      productTypetions: [],
      modalVisible: false,
      confirmLoading: false,
      initData: null,
      dialogTitle: null,
      form: {
        year: undefined
      },
      seriesData: [],
      xAxisData: [],
      legendData: [],
      yearsOptions: [],
      monthAmounts: [],
      pieSeriesData: [],
      totalAmountData: [],
      pieLegendData: []
    }
  },
  created () {
    this.loading = true
    this.fetchSearchOptions()
    this.queryTotal()
  },
  methods: {
    queryTotal () {
      this.dataSource = []
      this.dataSource = []
      this.xAxisData = []
      this.seriesData = []
      this.legendData = []
      this.pieSeriesData = []
      this.pieLegendData = []
      this.totalAmountData = []
      this.columns = [
        {
          title: '产品线',
          dataIndex: 'productTypeLineName',
          key: 'productTypeLineName',
          width: '100px'
        }
      ]
      this.fetchData()
    },
    async fetchSearchOptions () {
      for (let i = 2018; i <= new Date().getFullYear(); i++) {
        this.yearsOptions.unshift({ year: i, value: i })
      }
      this.form.year = new Date().getFullYear()
    },
    // 异步获取数据
    async fetchData () {
      this.loading = true
      await queryIncomeStatisticDetails({
        year: this.form.year
      }).then((data) => {
        this.dataSource = data.data ? data.data : []
        this.dataSourceTempt = data.data ? data.data : []
        this.dataMonths = data.months ? data.months : []

        this.dataMonths.map((item, index) => {
          this.columns.push({
            title: item.month + '月',
            dataIndex: item.month,
            key: item + index,
            width: '100px'
          })

          this.xAxisData.push(item.month + '月')
        })

        this.columns.push({
          title: '合计',
          dataIndex: 'totalAmount',
          key: 'totalAmount',
          width: '100px'
        })

        if (this.dataSourceTempt.length > 0) {
          let len = 0

          this.dataSourceTempt.map((item, index) => {
            len = len + 1
            this.monthAmounts = []
            item.months.map((innerItem) => {
              this.$set(this.dataSource[index],
                innerItem.month,
                innerItem.amount)
              this.monthAmounts.push(innerItem.amount)
            })
            this.seriesData[index] = ({
              name: item.productTypeLineName,
              type: 'line',
              data: this.monthAmounts,
              lineStyle: {
                width: 3
              }
              // itemStyle: {
              //   normal: {
              //     lineStyle: {
              //       width: 2// 0.1的线条是非常细的了
              //     }
              //   }
              // }
            })
            this.legendData.push(item.productTypeLineName)
            this.totalAmountData.push({ value: item.totalAmount, name: item.productTypeLineName })
          })

          this.pieSeriesData.push({
            name: '总计', // 饼图中内容介绍
            type: 'pie', // 统计表的类型
            radius: '60%', // 饼图的弧度，值越小生成的饼状图越小
            // center: ['50%', '55%'], // 饼图生成后的位置
            data: this.totalAmountData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
              // normal: {
              //   // 自定义饼状图每一份的颜色
              //   color: function (params) {
              //     var colorList = [
              //       '#44C0C1', '#188df0', '#FFFF00', '#FF8C00', '#FF0000', '#FE8463'
              //     ]
              //     return colorList[params.dataIndex]
              //   }
              // }
            }
          })

          this.dataSource.push({ productTypeLineName: '合计' })
          data.months.map((item, index) => {
            this.$set(this.dataSource[len],
              item.month,
              item.amount)
          })

          this.$set(this.dataSource[len],
            'totalAmount',
            data.totalAmount)
        }
        this.initEcharts()
      }
      )
      this.loading = false
    },
    initEcharts () {
      const option1 = {
        title: {
          text: '各产品收入分布走势',
          x: 'center', // x轴方向对齐方式
          top: 10, // 标题栏的高度，值越大，距离顶部的距离越大
          textStyle: {
            color: '#000' // 标题栏字体的颜色
          }
        },
        tooltip: {},
        legend: {
          orient: 'vertical',
          bottom: 'bottom',
          data: this.legendData
        },
        xAxis: {
          data: this.xAxisData
        },
        yAxis: {
          type: 'value',
          name: '元',
          axisLabel: {
            formatter: '{value}'
          },
          axisLine: {
            show: true
          }
        },
        series: this.seriesData
      }

      const option2 = {
        title: {
          text: '各产品收入结构图', // 主标题
          x: 'center', // x轴方向对齐方式
          top: 10, // 标题栏的高度，值越大，距离顶部的距离越大
          textStyle: {
            color: '#000' // 标题栏字体的颜色
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          bottom: 'bottom',
          data: this.legendData
        },
        series: this.pieSeriesData
      }
      const myChart = this.$echarts.init(document.getElementById('mychart'))// 图标初始化
      const myPieChart = this.$echarts.init(document.getElementById('myPieChart'))// 图标初始化

      myChart.setOption(option1)// 渲染页面
      myPieChart.setOption(option2)
      // 随着屏幕大小调节图表
      window.addEventListener('resize', () => {
        myChart.resize()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 16px;
}

.mychart {
  width: 100%;
  height: 400px;
}

.myPieChart {
  width: 100%;
  height: 400px;
  margin-top: 30px;
}
</style>
